// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__zHQNr","loader":"Loader_loader__ibL-F","loader_animation":"Loader_loader_animation__uQo+w"};